//BlueHandsPostJob.jsx
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate, useParams, Link } from 'react-router-dom';
import Loader from '../../components/utils/Loader';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { 
//   faBullseye, faCheckToSlot, faClock, faCopy, faEarth, faExclamationTriangle, faFileVideo, faHeartPulse, 
//   faLightbulb, faListCheck, faLock, faMapLocation, faMicrochip, faMicrophone, faPen, faQrcode, faUpload
//   } from '@fortawesome/free-solid-svg-icons';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../../styles/Concerns.css';
import '../../styles/Alert.css';

const BlueHandsPostJob = () => {
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();
  const [fetchData, { loading }] = useFetch();
  const { jobId } = useParams();
  const mode = jobId === undefined ? "add" : "update";
  const [job, setJob] = useState(null);
  const [userId, setUserId] = useState(authState.user._id);
  const [userName, setUserName] = useState(authState.user.name);
  const [userCode, setUserCode] = useState(authState.user.think5whyscode);
  const [category, setCategory] = useState("Labour");
  const [searchCity, setSearchCity] = useState("Mumbai");
  const [customCity, setCustomCity] = useState("");
  const [countFormErrors, setCountFormErrors] = useState(0);
  const [formErrors, setFormErrors] = useState({});
  const [showAlert, setShowAlert] = useState(false);
  const [error, setError] = useState(null);

  const [formData, setFormData] = useState({
    employerId: null,
    employerCode: "",
    employerName: authState.user.name,
    employerAddress: "",
    employerDetails: "",
    jobCode: "",
    jobKeyword: "",
    jobCategory: "Highly Skilled",
    jobLocation: "Mumbai",
    jobTitle: "",
    department: "",
    jobDescription: "",
    vacancies: "",
    salaryDetails: "",
    splRemarks: "",
    isActive: true,    
    isDeleted: false,  
    createdBy: userId, 
    datePosted: new Date(),  
    applyFromDate: new Date(),  
    applyToDate: new Date(),  
    isReopen: false,
    isInstant: false,
  });
  
  useEffect(() => {
    document.title = mode === "add" ? "Add" : "Update";
  }, [mode]);

  useEffect(() => {
    if (mode === "update") {
      const config = { 
        url: "/bluejobs/getforupdate",
        method: "post", 
        headers: { Authorization: authState.token }, 
        data: { jobId: jobId }
      };
      // console.log("Getting Data for Update here", config);
  
      fetchData(config, { showSuccessToast: false })
        .then((data) => {
          setJob(data.jobData);
          setFormData({
            employerId: data.job.employerId,
            employerCode: data.job.employerCode,
            employerName: data.job.employerName,
            employerAddress: data.job.employerAddress,
            employerDetails: data.job.employerDetails,
            jobCode: data.job.jobCode,
            jobKeyword: data.job.jobKeyword,
            jobCategory: data.job.jobCategory,
            jobLocation: data.job.jobLocation,
            jobTitle: data.job.jobTitle,
            department: data.job.department,
            jobDescription: data.job.jobDescription,
            vacancies: data.job.vacancies,
            salaryDetails: data.job.salaryDetails,
            splRemarks: data.job.splRemarks,
            isActive: data.job.isActive,
            isDeleted: data.job.isDeleted,
            createdBy: data.job.createdBy,
            datePosted: data.job.datePosted,  
            applyFromDate: data.job.applyFromDate,  
            applyToDate: data.job.applyToDate, 
            isReopen: data.job.isReopen,
            isInstant: data.job.isInstant,
          });
        })
        .catch((error) => {
          console.error("Error Fetching Posted Job Data:", error);
          setError("Error Fetching Posted Job Data");
        });
    }
  }, [mode, authState, jobId, fetchData, setJob]);
  

  const handleChange = (e) => {
    setFormData({
      ...formData, [e.target.name]: e.target.value
    });
  };

  const handleSubmit = e => {
    e.preventDefault();
    const error = validateForm(formData);
    // console.log("error : ",error," no. of error",Object.keys(error).length);
    setFormErrors(error);
    setCountFormErrors(Object.keys(error).length);
    // console.log("setFormError : ",setFormErrors);

    if (Object.keys(error).length > 0) {
      setFormErrors(
        Object.keys(error).reduce((total, key) => {
          total[key] = error[key];
          return total;
        }, {})
      );
      return;
    }

    if (mode === "add") {
      const config = { 
        url: "/bluejobs/createjob", 
        method: "post",
        data: {formData: formData, user: userId}, 
        headers: { Authorization: authState.token } 
      };
      // console.log("Posting Data ",JSON.stringify(formData, null, 2), " User ",authState.user._id);


      fetchData(config).then(() => {
        navigate("/bluehands-myjobpost-list");
      });
    }
    else {
      const config = { 
        url: "/bluejobs/updatejob", 
        method: "post", 
        data: {formData: formData, jobId: jobId}, 
        headers: { Authorization: authState.token } 
      };
      // console.log("Posting Data for ",config);

      fetchData(config).then(() => {
        navigate("/bluehands-myjobpost-list");
      })
      .catch((error) => {
        console.error("Error updating Job Posting:", error);
        setError("Error updating Job Posting");
      });
    }
  }

  const validateForm = formData => {
    const errors = {};
    if (!category) {
      errors.category = "Job Category is required";
    }
    if (!searchCity) {
      errors.searchCity = "Location is required";
    }
    if (!formData.jobCode) {
      errors.jobCode = "Job Code is required";
    } 
    if (!formData.jobTitle) {
      errors.jobTitle = "Job Title is required";
    } else if (formData.jobTitle.length > 100) {
      errors.jobTitle = "Job Title cannot exceed 100 characters";
    }
    if (!formData.jobDescription) {
      errors.jobDescription = "Description is required";
    } else if (formData.jobDescription.length > 2500) {
      errors.jobDescription = "Description cannot exceed 2500 characters";
    }
    if (!formData.employerCode) {
      errors.employerCode = "Employer Code is required";
    } 
    if (!formData.employerName) {
      errors.employerName = "Employer Name is required";
    } 
    return errors;
  }

  const fieldError = (field) => (
    <p className={`mt-1 text-pink-600 text-sm ${formErrors[field] ? "block" : "hidden"}`}>
      <i className='mr-2 fa-solid fa-circle-exclamation'></i>
      {formErrors[field]}
    </p>
  )

  return (
    <>
      <MainLayout>
      <div className="min-h-full py-4 px-4 bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 mt-12 rounded-lg">
        <h2 className='text-2xl font-bold text-white text-center mb-2'>My BlueHand Jobs Posting</h2>
            {loading ? (
              <Loader />
            ) : (
            <div className='text-sm'>
              <div className='flex justify-center'>
                <h2 className="text-xl text-yellow-200">{mode === "add" ? "Post New Blue Job" : "Edit Blue Job"}</h2>
              </div>
              <div className="border-container-gray ml-8">
                <div className="flex flex-col mt-4">
                <p>Job Category*:</p>
                <select
                  value={category}
                  onChange={(e) => setCategory(e.target.value)}
                  className="border border-gray-300 rounded-md px-4 py-2 w-full md:w-auto focus:outline-none focus:ring-2 focus:ring-blue-500"
                  style={{ border: '1px solid #ccc', padding: '8px', height: '36px', minHeight: '40px', width: "300px" }}
                >
                  <option value="">Select a Category</option>
                  
                  <optgroup label="Industrial & Manufacturing">
                    <option value="Factory Worker">Factory Worker</option>
                    <option value="Machine Operator">Machine Operator</option>
                    <option value="Welder">Welder</option>
                  </optgroup>

                  <optgroup label="Construction & Infrastructure">
                    <option value="Mason">Mason</option>
                    <option value="Carpenter">Carpenter</option>
                    <option value="Electrician">Electrician</option>
                    <option value="Plumber">Plumber</option>
                  </optgroup>

                  <optgroup label="Agriculture & Farming">
                    <option value="Farm Labourer">Farm Labourer</option>
                    <option value="Harvesting Worker">Harvesting Worker</option>
                    <option value="Irrigation Technician">Irrigation Technician</option>
                  </optgroup>

                  <optgroup label="Transportation & Logistics">
                    <option value="Truck Driver">Truck Driver</option>
                    <option value="Warehouse Worker">Warehouse Worker</option>
                  </optgroup>

                  <optgroup label="Mining & Extraction">
                    <option value="Coal Miner">Coal Miner</option>
                    <option value="Oil Rig Worker">Oil Rig Worker</option>
                  </optgroup>

                  <optgroup label="Domestic & Cleaning">
                    <option value="Housekeeper">Housekeeper</option>
                    <option value="Janitor">Janitor</option>
                  </optgroup>

                  <optgroup label="Security & Public Safety">
                    <option value="Security Guard">Security Guard</option>
                    <option value="Firefighter">Firefighter</option>
                  </optgroup>

                  <optgroup label="Hospitality & Food Service">
                    <option value="Kitchen Helper">Kitchen Helper</option>
                    <option value="Dishwasher">Dishwasher</option>
                  </optgroup>

                  <optgroup label="Textile & Garment">
                    <option value="Tailor">Tailor</option>
                    <option value="Weaver">Weaver</option>
                  </optgroup>

                  <optgroup label="General & Unskilled Labour">
                    <option value="Construction Helper">Construction Helper</option>
                    <option value="Daily Wage Labourer">Daily Wage Labourer</option>
                  </optgroup>

                  <optgroup label="Other Roles">
                    <option value="Highly Skilled">Highly Skilled</option>
                    <option value="Labour">Labour</option>
                    <option value="Contractor">Contractor</option>
                    <option value="Consultant">Consultant</option>
                    <option value="Company">Company</option>
                    <option value="Supervisor">Supervisor</option>
                  </optgroup>

                </select>
              </div>

                <div className='flex flex-col'>
                  <p>Select Location*:</p>
                  <select
                    value={searchCity}
                    onChange={(e) => setSearchCity(e.target.value)}
                    className="border border-gray-300 rounded-md px-4 py-3 w-full md:w-auto focus:outline-none focus:ring-2 focus:ring-blue-500 text-base"
                    style={{ border: '1px solid #ccc', padding: '8px', height: '36px', minHeight: '36px', width: "300px" }}
                    >
                    <option value="Mumbai">Mumbai</option>
                    <option value="Delhi">Delhi</option>
                    <option value="Bangalore">Bangalore</option>
                    <option value="Ahmedabad">Ahmedabad</option>
                    <option value="Hyderabad">Hyderabad</option>
                    <option value="Chennai">Chennai</option>
                    <option value="Pune">Pune</option>
                    <option value="">Other Location</option>
                  </select>
              </div>
              { searchCity === "" && (
                <div className='mt-4'>
                  <input
                    type="text"
                    placeholder="Enter location"
                    value={customCity}
                    onChange={(e) => setCustomCity(e.target.value)}
                    className="border border-gray-300 rounded-md px-4 py-2 w-full md:w-auto focus:outline-none focus:ring-2 focus:ring-blue-500"
                    style= {{width: "300px"}}
                  />
                </div>
              )}
            </div>
            <div className="border-container">
              <div className="mb-2 text-sm">
                <label htmlFor="jobTitle">Job Title*:</label>
                <br />
                <input 
                  type="text" 
                  name="jobTitle" 
                  id="jobTitle" 
                  value={formData.jobTitle} 
                  placeholder="Enter the jobTitle..."
                  maxLength="100"
                  onChange={handleChange}
                  style={{
                    border: '1px solid #ccc',
                    padding: '8px',
                    width: '100%',
                    boxSizing: 'border-box',
                  }} 
                />
                {fieldError("jobTitle")}
              </div>
              <div className="mb-2 text-sm">
                <label htmlFor="jobCode">Job Code*:</label>
                <br />
                <input 
                  type="text" 
                  name="jobCode" 
                  id="jobCode" 
                  value={formData.jobCode} 
                  placeholder="Enter the jobCode..."
                  maxLength="50"
                  onChange={handleChange}
                  style={{
                    border: '1px solid #ccc',
                    padding: '8px',
                    width: '150px',
                    boxSizing: 'border-box',
                  }} 
                />
                {fieldError("jobCode")}
              </div>
                 
              <div className="mb-2 text-sm text-white">
                <p>Job Description*:</p>
                  <textarea 
                    type="text" 
                    name="jobDescription" 
                    id="jobDescription" 
                    value={formData.jobDescription}
                    placeholder={"Write here.."}
                    onChange={handleChange}
                    maxLength="2000"
                    style={{
                      border: '1px solid #ccc',
                      padding: '2px',
                      backgroundColor: '#f0f0f0', 
                      color: '#000000',
                      maxWidth: '100%', 
                      maxHeight: '150px' 
                    }}
                  />
                  {fieldError("jobDescription")}
                </div>
                <div className="mb-2 text-sm">
                  <label htmlFor="department">Department:</label>
                  <br />
                  <input type="text" name="department" id="department" value={formData.department} placeholder="Enter Department ..."
                    onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '200px', height: '36px' }} />
                  {fieldError("department")}
                </div>
                
                <div className="mb-2 text-sm">
                  <label htmlFor="vacancies">Number of Vacancies:</label>
                  <br />
                  <input type="text" name="vacancies" id="vacancies" value={formData.vacancies} 
                    onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '100px', height: '36px' }} />
                  {fieldError("vacancies")}
                </div>
                <div className="mb-2 text-sm">
                  <label htmlFor="salaryDetails">Salary Details:</label>
                  <br />
                  <input type="text" name="salaryDetails" id="salaryDetails" value={formData.salaryDetails} placeholder="Enter Salary Details ..."
                    onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '100%', height: '36px' }} />
                  {fieldError("salaryDetails")}
                </div>
                <div className="mb-2 text-sm">
                  <label htmlFor="tags">Job Keyword:</label>
                  <br />
                  <input type="text" name="jobKeyword" id="jobKeyword" value={formData.jobKeyword} placeholder="Enter keywords seperated by a comma (,) ..."
                    onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '100%', height: '36px' }} />
                  {fieldError("jobKeyword")}
                </div>
                {/* </div> */}
                <div className="border-container">
                  <div className="mb-2 text-sm">
                    <label htmlFor="jobCode">Employer Code*:</label>
                    <br />
                    <input 
                      type="text" 
                      name="employerCode" 
                      id="employerCode" 
                      value={formData.employerCode} 
                      placeholder="Enter the Employer Code..."
                      maxLength="100"
                      onChange={handleChange}
                      style={{
                        border: '1px solid #ccc',
                        padding: '8px',
                        width: '150px',
                        boxSizing: 'border-box',
                      }} 
                    />
                    {fieldError("employerCode")}
                  </div>
                  <div className="mb-2 text-sm">
                    <label htmlFor="jobCode">Employer Name*:</label>
                    <br />
                    <input 
                      type="text" 
                      name="employerName" 
                      id="employerName" 
                      value={formData.employerName} 
                      placeholder="Enter the Employer Name..."
                      maxLength="100"
                      onChange={handleChange}
                      style={{
                        border: '1px solid #ccc',
                        padding: '8px',
                        width: '100%',
                        boxSizing: 'border-box',
                      }} 
                    />
                    {fieldError("employerName")}
                  </div>
                  <div className="mb-2 text-sm text-white">
                  <p>Employer Details*:</p>
                    <textarea 
                      type="text" 
                      name="employerDetails" 
                      id="employerDetails" 
                      value={formData.employerDetails}
                      placeholder={"Write here.."}
                      onChange={handleChange}
                      maxLength="2000"
                      style={{
                        border: '1px solid #ccc',
                        padding: '2px',
                        backgroundColor: '#f0f0f0', 
                        color: '#000000',
                        maxWidth: '100%', 
                        maxHeight: '150px' 
                      }}
                    />
                    {fieldError("employerDetails")}
                  </div>
                  <div className="mb-2 text-sm text-white">
                    <p>Employer Address*:</p>
                      <textarea 
                        type="text" 
                        name="employerAddress" 
                        id="employerAddress" 
                        value={formData.employerAddress}
                        placeholder={"Write here.."}
                        onChange={handleChange}
                        maxLength="2000"
                        style={{
                          border: '1px solid #ccc',
                          padding: '2px',
                          backgroundColor: '#f0f0f0', 
                          color: '#000000',
                          maxWidth: '100%', 
                          maxHeight: '150px' 
                        }}
                      />
                      {fieldError("v")}
                  </div>
                </div>
              </div>
              <div className="border-container">
                <div className="mb-2 text-sm">
                    <label>
                      <input className='mr-4' type="checkbox" checked={formData.isActive} onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })} />
                      Active
                    </label>
                  </div>
                  <div className="mb-2 text-sm">
                    <label>
                      <input className='mr-4' type="checkbox" checked={formData.isInstant} onChange={(e) => setFormData({ ...formData, isInstant: e.target.checked })} />
                      Instant Job
                    </label>
                  </div>
                  <div className="mb-2 text-sm">
                    <label>
                      <input className='mr-4' type="checkbox" checked={formData.isReopen} onChange={(e) => setFormData({ ...formData, isReopen: e.target.checked })} />
                      Reopened Job
                    </label>
                  </div>
              </div>
              <div className="border-container">
                <div className="mb-2 text-sm">
                  <label htmlFor="applyFromDate">Job Apply Start From*:</label>
                  <br />
                  <DatePicker
                    selected={formData.applyFromDate}
                    onChange={date => setFormData({ ...formData, applyFromDate: date })}
                    dateFormat="dd/MM/yyyy"
                    id="applyFromDate"
                    name="applyFromDate"
                    className="form-control h-8"
                    style={{width: "250px"}}
                  />
                  {fieldError("applyFromDate")}
                </div>
                <div className="mb-2 text-sm">
                  <label htmlFor="applyToDate">Job Apply End From*:</label>
                  <br />
                  <DatePicker
                    selected={formData.applyToDate}
                    onChange={date => setFormData({ ...formData, applyToDate: date })}
                    dateFormat="dd/MM/yyyy"
                    id="applyToDate"
                    name="applyToDate"
                    className="form-control h-8"
                    style={{width: "250px"}}
                  />
                  {fieldError("applyToDate")}
                </div>
                <div className="mb-2 text-sm text-white">
                  <p>Remarks*:</p>
                    <textarea 
                      type="text" 
                      name="splRemarks" 
                      id="splRemarks" 
                      value={formData.splRemarks}
                      placeholder={"Write here.."}
                      onChange={handleChange}
                      maxLength="2000"
                      style={{
                        border: '1px solid #ccc',
                        padding: '2px',
                        backgroundColor: '#f0f0f0', 
                        color: '#000000',
                        maxWidth: '100%', 
                        maxHeight: '150px' 
                      }}
                  />
                  {fieldError("splRemarks")}
                </div>
              </div>
            
              <div className="border-container flex flex-col justify-center">
                <div className="flex justify-center">
                  {Object.keys(formErrors).length > 0 && (
                    <div className="form-errors text-red-300 justify-center items-center">
                      {Object.keys(formErrors).map((key) => (
                        <div className="flex justify-center items-center" key={key}>{formErrors[key]}</div>
                      ))}
                    </div>
                  )}
                </div>

                <div className="flex justify-center">
                  <button 
                    className='bg-primary text-white px-4 py-2 font-medium hover:bg-primary-dark' 
                    onClick={handleSubmit}>
                      {mode === "add" ? "Add New" : "Update"}
                  </button>
                  <button 
                    className='ml-4 bg-red-500 text-white px-4 py-2 font-medium' 
                    onClick={() => navigate("/bluehands-myjobpost-list")}>
                      Cancel
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </MainLayout>
    </>
  )
}

export default BlueHandsPostJob;